import avatarAltermaind from './avatar/avatar-altermaind.png';
import avatarFederica from './avatar/avatar-federica.png';
import office from './avatar/office.jpg';
import backgroundConfig from './background-config.png';
import configExampleDark from './config-example-dark.png';
import configExampleLight from './config-example-light.png';
import tutorialLearningDepartmentSlide1 from './learning/tutorial/department/tutorialLearningDepartmentSlide1.png';
import tutorialLearningDepartmentSlide2 from './learning/tutorial/department/tutorialLearningDepartmentSlide2.png';
import tutorialLearningDepartmentSlide3 from './learning/tutorial/department/tutorialLearningDepartmentSlide3.png';
import tutorialLearningDepartmentSlide4 from './learning/tutorial/department/tutorialLearningDepartmentSlide4.png';
import tutorialManagerSlide1 from './learning/tutorial/homepage/manager/tutorialManagerSlide1.png';
import tutorialManagerSlide2 from './learning/tutorial/homepage/manager/tutorialManagerSlide2.png';
import tutorialManagerSlide3 from './learning/tutorial/homepage/manager/tutorialManagerSlide3.png';
import tutorialManagerSlide4 from './learning/tutorial/homepage/manager/tutorialManagerSlide4.png';
import tutorialManagerSlide5 from './learning/tutorial/homepage/manager/tutorialManagerSlide5.png';
import tutorialTeamSlide1 from './learning/tutorial/homepage/teamLeader/tutorialTeamSlide1.png';
import tutorialTeamSlide2 from './learning/tutorial/homepage/teamLeader/tutorialTeamSlide2.png';
import tutorialTeamSlide3 from './learning/tutorial/homepage/teamLeader/tutorialTeamSlide3.png';
import tutorialTeamSlide4 from './learning/tutorial/homepage/teamLeader/tutorialTeamSlide4.png';
import tutorialTeamSlide5 from './learning/tutorial/homepage/teamLeader/tutorialTeamSlide5.png';
import tutorialLearningTeamSlide1 from './learning/tutorial/team/tutorialLearningTeamSlide1.png';
import tutorialLearningTeamSlide2 from './learning/tutorial/team/tutorialLearningTeamSlide2.png';
import tutorialLearningTeamSlide3 from './learning/tutorial/team/tutorialLearningTeamSlide3.png';
import logoDark from './logo.dark.png';
import logoLight from './logo.light.png';
import logoAltermaind from './logoAltermaind.png';
import slide1 from './slide-1.png';
import bgCourses from './training/bg-courses.png';
import bgPlayGround from './training/bg-playground.png';
import catalog1 from './training/catalog1.png';
import catalog2 from './training/catalog2.png';
import catalog3 from './training/catalog3.png';
import catalog4 from './training/catalog4.png';
import howItWorks from './training/come-funziona.png';
import gamification from './training/gamification.png';
import bgPlaygroundCard from './training/playground/bgCard.png';
import introPlayground from './training/playground/intro.png';
import introPlaygroundLearning from './training/playground/introLearning.png';
import programs from './training/playground/programs.png';
import playGroundImage from './training/playground-image.png';
import doubleBoxQuestions from './training/quiz/double-box-questions.png';
import tutorialAssessmentEmployeeSlide1 from './tutorial/assessment/employee/tutorialAssessmentEmployeeSlide1.png';
import tutorialAssessmentEmployeeSlide2 from './tutorial/assessment/employee/tutorialAssessmentEmployeeSlide2.png';
import tutorialAssessmentManagerSlide1 from './tutorial/assessment/manager/tutorialAssessmentManagerSlide1.png';
import tutorialAssessmentManagerSlide2 from './tutorial/assessment/manager/tutorialAssessmentManagerSlide2.png';
import tutorialAssessmentTeamSlide1 from './tutorial/assessment/team/tutorialAssessmentTeamSlide1.png';
import tutorialAssessmentTeamSlide2 from './tutorial/assessment/team/tutorialAssessmentTeamSlide2.png';
import departmentsTutorialImage from './tutorial/departments/departmentsTutorialImage.png';
import tutorialDepartmentsSlide1 from './tutorial/departments/tutorialDepartmentsSlide1.jpg';
import tutorialDepartmentsSlide2 from './tutorial/departments/tutorialDepartmentsSlide2.jpg';
import tutorialDepartmentsSlide3 from './tutorial/departments/tutorialDepartmentsSlide3.jpg';
import tutorialEmployeeSlide1 from './tutorial/employee/tutorialEmployeeSlide1.png';
import tutorialEmployeeSlide2 from './tutorial/employee/tutorialEmployeeSlide2.png';
import tutorialEmployeeSlide3 from './tutorial/employee/tutorialEmployeeSlide3.png';
import tutorialEmployeeSlide4 from './tutorial/employee/tutorialEmployeeSlide4.png';
import tutorialFirstTutorialSlide1 from './tutorial/firstTutorial/tutorialFirstTutorialSlide1.png';
import tutorialFirstTutorialSlide2 from './tutorial/firstTutorial/tutorialFirstTutorialSlide2.png';
import tutorialFirstTutorialSlide3 from './tutorial/firstTutorial/tutorialFirstTutorialSlide3.png';
import tutorialFirstTutorialSlide4 from './tutorial/firstTutorial/tutorialFirstTutorialSlide4.png';
import peopleTutorialImage from './tutorial/people/peopleTutorialImage.png';
import tutorialPeopleSlide1 from './tutorial/people/tutorialPeopleSlide1.jpg';
import tutorialPeopleSlide2 from './tutorial/people/tutorialPeopleSlide2.jpg';
import tutorialPeopleSlide3 from './tutorial/people/tutorialPeopleSlide3.jpg';
import tutorialPeopleSlide4 from './tutorial/people/tutorialPeopleSlide4.jpg';
import tutorialReportsAssessmentsSlide1 from './tutorial/reports/assessments/tutorialReportsAssessmentsSlide1.png';
import tutorialReportsAssessmentsSlide2 from './tutorial/reports/assessments/tutorialReportsAssessmentsSlide2.png';
import tutorialReportsAssessmentsSlide3 from './tutorial/reports/assessments/tutorialReportsAssessmentsSlide3.png';
import tutorialReportsTrainingsSlide1 from './tutorial/reports/trainings/tutorialReportsTrainingsSlide1.png';
import tutorialReportsTrainingsSlide2 from './tutorial/reports/trainings/tutorialReportsTrainingsSlide2.png';
import tutorialReportsTrainingsSlide3 from './tutorial/reports/trainings/tutorialReportsTrainingsSlide3.png';
import tutorialSettingPlanSlide1 from './tutorial/settings/plan/tutorialSettingPlanSlide1.png';
import tutorialAspectSlide1 from './tutorial/settings/tutorialAspectSlide1.png';
import tutorialOrganizationSlide1 from './tutorial/settings/tutorialOrganizationSlide1.jpg';
import tutorialOrganizationSlide3 from './tutorial/settings/tutorialOrganizationSlide3.jpg';
import tutorialOrganizationSlide4 from './tutorial/settings/tutorialOrganizationSlide4.png';
import tutorialSurveysHardSkillsSlide1 from './tutorial/surveys/tutorialSurveysHardSkillsSlide1.png';
import tutorialSurveysHardSkillsSlide2 from './tutorial/surveys/tutorialSurveysHardSkillsSlide2.png';
import tutorialSurveysHardSkillsSlide3 from './tutorial/surveys/tutorialSurveysHardSkillsSlide3.png';
import tutorialSurveysHardSkillsSlide4 from './tutorial/surveys/tutorialSurveysHardSkillsSlide4.png';
import tutorialSurveysHardSkillsSlide5 from './tutorial/surveys/tutorialSurveysHardSkillsSlide5.png';
import tutorialSurveysSoftSkillsSlide1 from './tutorial/surveys/tutorialSurveysSoftSkillsSlide1.jpg';
import tutorialSurveysSoftSkillsSlide2 from './tutorial/surveys/tutorialSurveysSoftSkillsSlide2.jpg';
import tutorialSurveysSoftSkillsSlide3 from './tutorial/surveys/tutorialSurveysSoftSkillsSlide3.jpg';
import tutorialSurveysSoftSkillsSlide4 from './tutorial/surveys/tutorialSurveysSoftSkillsSlide4.jpg';
import tutorialSurveysSoftSkillsSlide5 from './tutorial/surveys/tutorialSurveysSoftSkillsSlide5.jpg';
import tutorialSoftSkillsAiPlaygroundSlide1 from './tutorial/training/aiPlayground/tutorialAIPlaygroundSlide1.png';
import tutorialSoftSkillsAiPlaygroundSlide2 from './tutorial/training/aiPlayground/tutorialAIPlaygroundSlide2.png';
import tutorialHardSkillsAdminSlide1 from './tutorial/training/hardSkills/admin/tutorialHardSkillsSlide1.png';
import tutorialHardSkillsAdminSlide2 from './tutorial/training/hardSkills/admin/tutorialHardSkillsSlide2.png';
import tutorialHardSkillsAdminSlide3 from './tutorial/training/hardSkills/admin/tutorialHardSkillsSlide3.png';
import tutorialHardSkillsLearningSlide1 from './tutorial/training/hardSkills/learning/tutorialHardSkillsSlide1.png';
import tutorialHardSkillsLearningSlide2 from './tutorial/training/hardSkills/learning/tutorialHardSkillsSlide2.png';
import tutorialSoftSkillsAdminSlide1 from './tutorial/training/softSkills/admin/tutorialSoftSkillsSlide1.png';
import tutorialSoftSkillsAdminSlide2 from './tutorial/training/softSkills/admin/tutorialSoftSkillsSlide2.png';
import tutorialSoftSkillsAdminSlide3 from './tutorial/training/softSkills/admin/tutorialSoftSkillsSlide3.png';
import tutorialSoftSkillsLearningSlide1 from './tutorial/training/softSkills/learning/tutorialSoftSkillsSlide1.png';
import tutorialSoftSkillsLearningSlide2 from './tutorial/training/softSkills/learning/tutorialSoftSkillsSlide2.png';

export const images = {
  configExampleDark,
  configExampleLight,
  backgroundConfig,
  logoDark,
  logoLight,
  slide1,
  logoAltermaind,
  // tutorial first tutorial
  tutorialFirstTutorialSlide1,
  tutorialFirstTutorialSlide2,
  tutorialFirstTutorialSlide3,
  tutorialFirstTutorialSlide4,
  // tutorial organization
  tutorialOrganizationSlide1,
  tutorialOrganizationSlide3,
  tutorialOrganizationSlide4,
  // tutorial people
  peopleTutorialImage,
  tutorialPeopleSlide1,
  tutorialPeopleSlide2,
  tutorialPeopleSlide3,
  tutorialPeopleSlide4,
  // tutorial departments
  departmentsTutorialImage,
  tutorialDepartmentsSlide1,
  tutorialDepartmentsSlide2,
  tutorialDepartmentsSlide3,
  // tutorial employee
  tutorialEmployeeSlide1,
  tutorialEmployeeSlide2,
  tutorialEmployeeSlide3,
  tutorialEmployeeSlide4,
  // tutorial aspect
  tutorialAspectSlide1,
  // tutorial settings plan
  tutorialSettingPlanSlide1,
  // tutorial surveys
  tutorialSurveysSoftSkillsSlide1,
  tutorialSurveysSoftSkillsSlide2,
  tutorialSurveysSoftSkillsSlide3,
  tutorialSurveysSoftSkillsSlide4,
  tutorialSurveysSoftSkillsSlide5,
  tutorialSurveysHardSkillsSlide1,
  tutorialSurveysHardSkillsSlide2,
  tutorialSurveysHardSkillsSlide3,
  tutorialSurveysHardSkillsSlide4,
  tutorialSurveysHardSkillsSlide5,
  // training
  howItWorks,
  catalog1,
  catalog2,
  catalog3,
  catalog4,
  gamification,
  bgPlayGround,
  playGroundImage,
  bgCourses,
  // training playground
  introPlayground,
  bgPlaygroundCard,
  introPlaygroundLearning,
  programs,
  // avatar
  avatarAltermaind,
  avatarFederica,
  office,
  // training quiz
  doubleBoxQuestions,
  //
  // LEARNING PLATFORM
  //
  // section /homepage
  // tutorial manager
  tutorialManagerSlide1,
  tutorialManagerSlide2,
  tutorialManagerSlide3,
  tutorialManagerSlide4,
  tutorialManagerSlide5,
  // tutorial team leader
  tutorialTeamSlide1,
  tutorialTeamSlide2,
  tutorialTeamSlide3,
  tutorialTeamSlide4,
  tutorialTeamSlide5,
  // section /department
  // tutorial
  tutorialLearningDepartmentSlide1,
  tutorialLearningDepartmentSlide2,
  tutorialLearningDepartmentSlide3,
  tutorialLearningDepartmentSlide4,
  // section /team
  // tutorial
  tutorialLearningTeamSlide1,
  tutorialLearningTeamSlide2,
  tutorialLearningTeamSlide3,
  // section /assessment/:id
  // tutorial
  tutorialAssessmentTeamSlide1,
  tutorialAssessmentTeamSlide2,
  tutorialAssessmentManagerSlide1,
  tutorialAssessmentManagerSlide2,
  tutorialAssessmentEmployeeSlide1,
  tutorialAssessmentEmployeeSlide2,
  // section /training/ai-playground
  // tutorial
  tutorialSoftSkillsAiPlaygroundSlide1,
  tutorialSoftSkillsAiPlaygroundSlide2,
  // section /training/soft-skills
  // tutorial
  tutorialSoftSkillsAdminSlide1,
  tutorialSoftSkillsAdminSlide2,
  tutorialSoftSkillsAdminSlide3,
  tutorialSoftSkillsLearningSlide1,
  tutorialSoftSkillsLearningSlide2,
  // section /training/hard-skills
  // tutorial
  tutorialHardSkillsLearningSlide1,
  tutorialHardSkillsLearningSlide2,
  tutorialHardSkillsAdminSlide1,
  tutorialHardSkillsAdminSlide2,
  tutorialHardSkillsAdminSlide3,
  // section /reports/assessments
  tutorialReportsAssessmentsSlide1,
  tutorialReportsAssessmentsSlide2,
  tutorialReportsAssessmentsSlide3,
  // section /reports/trainings
  tutorialReportsTrainingsSlide1,
  tutorialReportsTrainingsSlide2,
  tutorialReportsTrainingsSlide3,
};
